import { useEffect, useState } from "react";

export const useCountdown = (shouldResetCountdown: boolean, duration: number, retryDelay: number = 5000) => {
  const [secondsLeft, setSecondsLeft] = useState<number>(duration);
  const [isRetrying, setIsRetrying] = useState(false);

  useEffect(() => {
    if (shouldResetCountdown || isRetrying) {
      setSecondsLeft(duration);
      return;
    }

    setSecondsLeft(duration);

    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          setIsRetrying(true);
          return duration;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [shouldResetCountdown, duration, isRetrying]);

  useEffect(() => {
    if (!isRetrying) return;

    const timeout = setTimeout(() => {
      setIsRetrying(false);
    }, retryDelay);

    return () => clearTimeout(timeout);
  }, [isRetrying, retryDelay]);

  return { secondsLeft, isRetrying };
};
